import query from './query'

export default function pushState(obj) {
  var url = location.pathname + query(obj, { mock: true })
  history.pushState(obj, '', url)
}
